import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { useSelectedOrganization } from "../../organization/hooks/useSelectedOrganization";
import { CouponDto, GET_COUPONS_QUERY_KEY } from "./useListCoupons";

export type CreateCouponInput = {
    name: string;
    discountType: 'PERCENTAGE' | 'FIXED';
    discountValue: number;
    currency?: string;
    applicableTo: string[];
    expiresAt: string;
    maxUsagePerUser?: number;
};

export const useCreateCoupon = () => {
    const client = useApiClient();
    const queryClient = useQueryClient();
    const { selectedOrganization } = useSelectedOrganization();

    return useMutation({
        mutationFn: (input: CreateCouponInput) =>
            client.fetchApi<CouponDto, CreateCouponInput>({
                endpoint: `coupons/admin/${selectedOrganization?.id}`,
                method: 'POST',
                body: input,
            }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: GET_COUPONS_QUERY_KEY(selectedOrganization?.id || '') });
        },
    });
};
